import { z } from 'zod';

const creatableRoles = ['admin', 'rh', 'comptable', 'lecture', 'salarie'] as const;

export const UserCreateSchema = z
  .object({
    prenom: z.string().min(1, 'Prénom requis').max(100),
    nom: z.string().min(1, 'Nom requis').max(100),
    email: z.string().email('Email invalide'),
    password: z.string().min(8, 'Mot de passe : 8 caractères minimum'),
    role: z.enum(creatableRoles, { error: 'Profil requis' }),
  })
  .superRefine((data, ctx) => {
    if (data.password.toLowerCase() === data.email.toLowerCase()) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        path: ['password'],
        message: 'Le mot de passe ne peut pas être identique à l’e-mail',
      });
    }
  });

export type UserCreateInput = z.infer<typeof UserCreateSchema>;

export const UserRoleUpdateSchema = z.object({
  role: z.enum(creatableRoles, { error: 'Profil requis' }),
});

export type UserRoleUpdateInput = z.infer<typeof UserRoleUpdateSchema>;
